// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresSquareReleaseBody = {
  poolId: string;
  gridId: string;
  squareKey: string;
};

export type typeSquaresSquareReleaseOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { squareKey: string; mySquareCount: number };
};

export type typeSquaresSquareReleaseOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresSquareReleaseOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresSquareReleaseOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresSquareReleaseBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    gridId: { type: "string", maxLength: 3000, minLength: 1 },
    squareKey: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "gridId", "squareKey"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresSquareRelease(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresSquareReleaseBody);
  }

  return async function postSquaresSquareRelease(
    payload: typeSquaresSquareReleaseBody,
  ): Promise<
    typeSquaresSquareReleaseOutput200 | typeSquaresSquareReleaseOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresSquareRelease" failed before calling the network. #da2392d8dc04`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#da2392d8dc04" },
        },
        data: null,
      } as typeSquaresSquareReleaseOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/square-release`,
      httpMethod: "POST",
      options,
    })) as
      typeSquaresSquareReleaseOutput200 | typeSquaresSquareReleaseOutput400;
  };
}
